
import moment from 'moment'
import StreetData from './StreetData'
import TypeData from './TypeData'
import WardData from './WardData'
import DirectionData from'./DirectionData'
import StructureData from './StructureData'
import LandUsageTypeData from './LandUsageTypeData'
import LineTypeData from './LineTypeData'

var table = {
    name: 'realestate.products',
    list_views: {
        filters: [
            {
                col: 'status',
                type: 'multi-select',
                value: ['Đang bán'],
            },
            {
                col: 'code',
                type: 'text',
                value: null
            },
            {
                col: 'fullname',
                type: 'text',
                value: null,
            },
            {
                col: 'sale',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'ward',
                type: 'multi-select',
                value: null,
            },
            {
                col: 'street',
                type: 'text',
                value: null,
            },
            {
                col: 'project',
                type: 'select',
                value: null,
            },
            {
                col: 'address',
                type: 'text',
                value: null,
            },
            {
                col: 'area',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'price',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'priceForRent',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'type',
                type: 'multi-select',
                
                text_search_type:'fuzzy',
                value: null
            },
            {
                col: 'structure',
                type: 'multi-select',
                value: null
            },

            {
                col: 'direction',
                type: 'multi-select',
                
                value: null
            },
            {
                col: 'phone',
                type: 'text',
                value: null
            },
            {
                col: 'usageType',
                type: 'multi-select',
                value: null
            },
            {
                col: 'isfavored',
                type: 'boolean',
                value: false
            },
            {
                col: 'isPosted',
                type: 'checkbox_special',
                value: false,
                condition: "NOT EXISTS (SELECT * FROM product_posting_summary as pps WHERE t.id = pps.id)"
            },
            {
                col: 'positive',
                type: 'multi-select',
                value: null,
                text_search_type:'fuzzy',
            },
            {
                col: 'areaWidth',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'contract_type',
                type: 'multi-select',
                value: [],
            }
        ],
        sorts: {
            date: 'desc',
            area: 'desc',
            price: 'desc'
        },
        columns: [
            {
                key: 'id',
                variant: 'warning'
            },
            'date',
            'code',
            'type',
            'fullname',
            // 'sale',
            'street',
            'address',
            {
                key: 'gps'
            },
            'price',
            'pricePerArea',
            'priceForRent',
            'notes',
            'area',
            'areaWidth',
            'areaLength',
            'trait',
            // 'positive',
            'structure',
            'direction',
            // 'priority',
            // 'urgency',
            // 'isfavored',
            // {
            //     name: 'isPosted',
            //     key: 'isPosted',
            //     is_virtual: true
            // },
        ]
    },
    input_view: {
        forms: [
            {
                col: 'status',
                type: 'select',
                value: 'Đang bán', // default value
                defaultValue: 'Đang bán',
                required: true,
                visible: true,
                colspan: 2
            },
            {
                col: 'sale',
                type: 'select',
                value: null, // default value
                required: true,
                visible: true,
                colspan: 2
            },
            {
                col: 'fullname',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                label: 'Họ tên - 4 sdt cuối',
                colspan: 3
            },
            {
                col: 'phone',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'type',
                type: 'multi-select',
                defaultValue: 'Chính chủ',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'ward',
                type: 'select',
                value: null, // default value
                required: true,
                visible: true,
                colspan:2,
                onInit: (formField, forms) => {
                    // we'll filter the street based on the value of this field
                    // if there is no value in this ward input, we'll leave the value as default
                    //
                    if(!formField.value) {
                        return;
                    }

                    
                    var newOptions = [];

                    for(var j=0; j<StreetData.street.length; j++) {
                        console.log(StreetData.street[j].ward + ' vs ' + formField.value);
                        if(StreetData.street[j].ward == formField.value) {
                            newOptions.push(StreetData.street[j]);
                        }
                    }
                     
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street') {
                            forms[i].options = newOptions;
                        }
                    }
                },
                change: (evt, forms) => {
                    // console.log('ward changed ', evt)
                    // console.log(StreetData.street);
                    // console.log(typeof evt);
                    var newOptions = [];

                    for(var j=0; j<StreetData.street.length; j++) {
                        // console.log(StreetData.street[j].ward + ' vs ' + evt);
                        if(StreetData.street[j].ward == evt) {
                            newOptions.push(StreetData.street[j]);
                        }
                    }
                     
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street') {
                            forms[i].options = newOptions;
                        }
                    }
                    
                    // console.log('new options: ', newOptions);
                }
            },
            {
                col: 'street_code',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                disabled: true,
                colspan:2,
            },
            {
                col: 'street',
                type: 'typeahead',
                defaultValue: '',
                value: '', // default value
                required: false,
                visible: true,
                colspan:8,

                options: StreetData.street,
                optionSerializer: opt => (opt.ward + ' > ' + opt.street + ' > ' + opt.street_2),
                optionLabel: opt => (opt.ward + ' > ' + opt.street + ' > ' + opt.street_2),
                optionValueName: 'code', // name of the attribute which will be stored inside the database
                hitFunction: (evt, forms, input) => {
                    

                    // update product_code automatically based on the street_code
                    var product_code = '';
                    for(var j=0; j<StreetData.street.length; j++) {
                        if(evt.code === StreetData.street[j].code) {
                            product_code += StreetData.street[j].street_code;
                            product_code += '.' + moment().format('MMDD.HH');
                        }
                    }

                    // update street code
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street_code') {
                            forms[i].value = evt.code;
                        }

                        if(forms[i].col === 'code') {
                            forms[i].value = product_code;
                        }
                    }
                }
            },

            {
                col: 'project',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'line',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'lineType',
                type: 'select',
                value: null, // default value
                required: false,
                defaultValue: 'Mặt tiền',
                visible: true,
                colspan: 4,
                hint: 'Mặt tiền (đường ôtô, có vỉa hè). Hẻm ôtô (>3m, không có vỉa hè). Hẻm xe máy (<3m)'
            },
            {
                col: 'address',
                type: 'textarea',
                value: null, // default value
                hint: 'Ghi rõ vị trí cụ thể và hướng dẫn đường đi tới BĐS',
                required: true,
                visible: true,
                colspan: 8
            },

            {
                col: 'gps',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },


            {
                col: 'splitter_1',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },

            {
                col: 'area',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'areaWidth',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'areaLength',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'quantity',
                type: 'number',
                value: 1, // default value
                defaultValue: 1,
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'usageType',
                type: 'multi-select',
                value: null, // default value
                defaultValue: 'ODT',
                required: false,
                visible: true,
                colspan: 4
            },
            

            {
                col: 'houseArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'houseAreaWidth',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'houseAreaLength',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            
            {
                col: 'houseUsageArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'direction',
                type: 'multi-select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'structure',
                type: 'multi-select',
                value: null, // default value
                defaultValue: 'Đất trống',
                required: true,
                visible: true,
                colspan: 4
            },


            {
                col: 'land_no',
                type: 'text',
                value: null, // default value
                defaultValue: '',
                required: false,
                visible: true,
                colspan: 2
            },


            {
                col: 'land_map_no',
                type: 'text',
                value: null, // default value
                defaultValue: '',
                required: false,
                visible: true,
                colspan: 2
            },
            
            {
                col: 'price',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2,
                validationFunc: (inputObj) => {
                    if(inputObj.value) {
                        var val = parseFloat(inputObj.value);
                        if(isNaN(val)) {
                            inputObj.error = "Định dạng số chưa đúng, vui lòng dùng '.' cho phần thập phân.";
                            return false;
                        }
                    }
                    
                    return true;
                }
            },
            
            {
                col: 'pricePerArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            {
                col: 'splitter_3',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },

            
            {
                col: 'trait',
                type: 'textarea',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 6
            },
            {
                col: 'notes',
                type: 'textarea',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 8
            },
            {
                col: 'priceForRent',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4,
                validationFunc: (inputObj) => {
                    if(inputObj.value) {
                        var val = parseFloat(inputObj.value);
                        if(isNaN(val)) {
                            inputObj.error = "Định dạng số chưa đúng, vui lòng dùng '.' cho phần thập phân.";
                            return false;
                        }
                    }
                    
                    return true;
                }
            },
            {
                col: 'splitter_4',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },
            {
                col: 'date',
                type: 'date',
                value: null,
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },
            {
                col: 'code',
                type: 'text',
                value: null, // default value
                defaultValue: function() {
                    return 'KG'+moment().format('YYMMDD-') + Math.floor(Math.random() * 99);
                } ,
                required: false,
                visible: true,
                colspan: 2,
                action_copy: true
            },
            {
                col: 'link',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            // {
            //     col: 'images',
            //     type: 'images',
            //     value: null, // default value
            //     required: false,
            //     visible: true,
            //     colspan: 12
            // },
            {
                col: 'positive',
                type: 'multi-select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'splitter_5',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },
            {
                col: 'contract_type',
                type: 'select',
                defaultValue: 'Không có HĐ',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'contract_start_date',
                type: 'date',
                value: null,
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },
            {
                col: 'contract_end_date',
                type: 'date',
                value: null,
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },
            {
                col: 'commission',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2

            },
            {
                col: 'image_list',
                type: 'image_list',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },
        ]},
    columns: {
        id: {
            'name': 'id',
            'type': 'id',
            'alias': 'ID'
        },
        date: {
            'name': 'date',
            'type': 'date',
            'alias': 'Ngày tháng',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            },
            'width': 50,
        },
        code: {
            'name': 'code',
            'type': 'text',
            'alias': 'Mã sản phẩm',
        },
        fullname: {
            'name': 'fullname',
            'type': 'text',
            'alias': 'Họ tên',
        },
        type: {
            'name': 'type',
            'type': 'text',
            'alias': 'Người rao bán',
            'visible': true,

            options: TypeData.data
        },
        sale: {
            'name': 'sale',
            'type': 'text',
            'alias': 'Sale',

            options: [
                'NHI',
                'TUẤN',
                'KIM',
                'CTV-NH',
                'NGUYÊN',
                'Telehang'
            ]
        },
        ward: {
            'name': 'ward',
            'type': 'text',
            'alias': 'Phường',
            
            options: WardData.data
        },
        street_code: {
            'name': 'street_code',
            'type': 'text',
            'alias': 'Mã đường',
            
            },
        street: {
            'name': 'street',
            'type': 'text',
            'alias': 'Tên đường',
            'width': 160,
        },
        project: {
            'name': 'project',
            'type': 'text',
            'alias': 'Tên dự án',
            'width': 160,
            options: [
                'Golden City',
                'Golden City GD2',
                'NOXH Golden City',
                'Lê Chân',
                'Làng Giáo Viên 2',
                'Lý Thái Tổ',
                'Nam Kinh',
                'Tây Sông Hậu',
                'Tây Sông Hậu GD2',
                'Tây Đại Học GD2',
                'Khu AB',
                'Khu Tỉnh đoàn',
                'Khu Nam Tầm Bót',
                'Xẻo Trôm 3',
               'VP Mỹ Quý',
                'Bắc Long Xuyên',
                'Phú Quý',
                'Phú Cường',
                'Chung cư Marina',
                'Khu Chợ Cái Sao',
                'An Châu Central',
                'Khu Chợ Cần Đăng'
            ]
        },
        address: {
            'name': 'address',
            'type': 'text',
            'alias': 'Địa chỉ',
            'width': 160,
        },
        price: {
            'name': 'price',
            'type': 'number',
            'alias': 'Giá kêu bán (tr)',
            // formatter: function(price) {
            //     if(price == 0) {
            //         return "";
            //     }
            //     else if(price < 1000) {
            //         return price + " triệu";
            //       }
            //       else {
            //         price = price / 1000;
            //         return price + " tỉ";
            //       }
            // }
        },

        priceForRent: {
            'name': 'priceForRent',
            'type': 'number',
            'alias': 'Giá cho thuê (tr)',
            // formatter: function(price) {
            //     if(price == 0) {
            //         return "";
            //     }
            //     else if(price < 1000) {
            //         return price + " triệu";
            //       }
            //       else {
            //         price = price / 1000;
            //         return price + " tỉ";
            //       }
            // }
        },

        pricePerArea: {
            'name': 'pricePerArea',
            'type': 'number',
            'alias': 'Giá theo m2 (tr)',
            formatter: function(price) {
                if(!price || price == 0) {
                    return "";
                }
                else {
                    return price.toFixed(1);
                }
            }
        },
        area: {
            'name': 'area',
            'type': 'number',
            'alias': 'Diện tích đất (m2)',
            // formatter: function(value) {
            //     return value + 'm2';
            // }
        },
        areaWidth: {
            'name': 'areaWidth',
            'type': 'number',
            'alias': 'Đất ngang (m)',
            // formatter: function(value) {
            //     return value + 'm';
            // }
        },
        areaLength: {
            'name': 'areaLength',
            'type': 'number',
            'alias': 'Đất dài (m)',
            // formatter: function(value) {
            //     return value + 'm';
            // }
        },
        structure: {
            'name': 'structure',
            'type': 'text',
            'alias': 'Kết cấu',
            options: StructureData.data
        },
        land_no: {
            'name': 'land_no',
            'type': 'text',
            'alias': 'Số thửa'
        },
        land_map_no: {
            'name': 'land_map_no',
            'type': 'text',
            'alias': 'Số tờ'
        },
        
        direction: {
            'name': 'direction',
            'type': 'text',
            'alias': 'Hướng',
            options: DirectionData.data
        },
        positive: {
            'name': 'positive',
            'type': 'text',
            'alias': 'Ưu điểm',
            options: [
                'Bán kín / Cho thuê kín',
                'Bán gấp giá TL mạnh',
                'NH định giá cao',
                'Thanh toán theo tiến độ',
                'Đang có dòng tiền cho thuê',
                'Hỗ trợ vay 3 bên',
                'Mặt tiền công viên',
                'Mặt tiền chợ',
                'View sông',
                'Hạ tầng điện nước âm',
                'Khu vực an ninh cao',
                'Mặt tiền rộng dễ tách thửa',
                'Vị trí Hiếm có',
                'Nền/Nhà Góc 2 mặt tiền',
                'Có 2 hẻm thông hành',
                'Không dính cống',
                'Không trụ điện',
                'Đất nở hậu',
                'Có mốc ranh rõ ràng',
                'Đất có quy hoạch dự án',
                'Nhà hợp thức hóa',
                'Nhà đẹp ở ngay',
                'Nhà mới xây',
                'Nhà xây thô',
                'Đầy đủ nội thất',
                'Có PN tầng trệt',
                'Có sân oto',
                'Có sân thượng',
                'Có sân vườn',
                'Có thang máy'
            ],
            'width': 50,
        },
        trait: {
            'name': 'trait',
            'type': 'text',
            'alias': 'Đặc điểm',
        },
        quantity: {
            'name': 'quantity',
            'type': 'number',
            'alias': 'Số lô'
        },
        usageType: {
            'name': 'usageType',
            'type': 'text',
            'alias': 'Loại đất',
            options: LandUsageTypeData.data
        },
        line: {
            'name': 'line',
            'type': 'number',
            'alias': 'Lòng đường (m)'
        },
        lineType: {
            'name': 'lineType',
            'type': 'text',
            'alias': 'Loại đường',
            options: LineTypeData.data
            
        },
        houseArea: {
            'name': 'houseArea',
            'type': 'number',
            'alias': 'Diện tích nhà (m2)'
        },
        houseAreaWidth: {
            'name': 'houseAreaWidth',
            'type': 'number',
            'alias': 'Nhà ngang (m)'
        },
        houseAreaLength: {
            'name': 'houseAreaLength',
            'type': 'number',
            'alias': 'Nhà dài (m)'
        },
        houseUsageArea: {
            'name': 'houseUsageArea',
            'type': 'number',
            'alias': 'Diện tích sàn (m2)'
        },
        gps: {
            'name': 'gps',
            'type': 'text',
            'alias': 'Định vị'
        },
        corner: {
            'name': 'corner',
            'type': 'text',
            'alias': 'Nền góc'
        },
        phone: {
            'name': 'phone',
            'type': 'text',
            'alias': 'Số điện thoại'
        },
        link: {
            'name': 'link',
            'type': 'text',
            'alias': 'Link'
        },
        notes: {
            'name': 'notes',
            'type': 'text',
            'alias': 'Chú ý'
        },
        contract_type: {
            'name': 'contract_type',
            'type': 'text',
            'alias': 'Hợp đồng môi giới',
            options: [
                'Không có HĐ',
                'Ký HĐ MG',
                'Ký HĐ MG độc quyền'
            ]
        },
        contract_start_date: {
            'name': 'contract_start_date',
            'type': 'date',
            'alias': 'HĐ Từ ngày',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            },
            'width': 50,
        },
        contract_end_date: {
            'name': 'contract_end_date',
            'type': 'date',
            'alias': 'HĐ Đến ngày',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            },
            'width': 50,
        },
        commission: {
            'name': 'commission',
            'type': 'text',
            'alias': 'Phí môi giới'
        },
        status: {
            'name': 'status',
            'type': 'text',
            'alias': 'Trạng thái',
            options: [
                'Đang bán',
                'Bán hoặc Cho thuê',
                'Đã bán',
                'Ngưng bán',
                'Cho thuê',
                'Ngưng cho thuê'
            ]
        },
        images: {
            'name': 'images',
            'type': 'text',
            'alias': 'Hình ảnh'
        },
        priority: {
            'name': 'priority',
            'type': 'number',
            'alias': 'SP Hot'
        },
        urgency: {
            'name': 'urgency',
            'type': 'number',
            'alias': 'Cần bán gấp'
        },
        image_list: {
            'name': 'image_list',
            'type': 'json',
            'alias': 'Hình ảnh'
        },
        isfavored: {
            'name': 'isfavored',
            'type': 'boolean',
            'alias': 'Ưa thích'
        },
        isPosted: {
            'name': 'isPosted',
            'type': 'checkbox_special',
            'alias': 'Chưa Đăng tin'
        }
    }
}

export default {
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    input_view: table.input_view,
    columns: table.columns
}